/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/role-has-required-aria-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
	useState,
} from 'react';
import {
	useLiveQuery,
} from 'dexie-react-hooks';
import Accordion from 'components/accordion/Accordion';
import TransportListCardDetails from './TransportListCardDetails';
import {
	Assignment,
	Direction,
} from 'models/assignment.model';
import {
	database,
} from 'utils/database';
import {
	SvgPickup,
	SvgDelivery,
	SvgDeviation,
	SvgElectrical,
	SvgHighPriority,
} from 'components/svg/Svg';
import {
	AssignmentFilterType, getAliasForGLN,
	isDone,
} from 'utils/transport';
import './transportListCardHeader.scss';
import {
	DangerousGoodsIcon,
} from './dangerousGoods/DangerousGoodsIcon';
import {
	DangerousGoodsModel,
} from 'models';
import TransportCompleted from './transport-completed.svg';

interface SvgProps {
	isAssignmentDone: boolean,
	direction: string,
}

const TripDirectionSvg = ({
	isAssignmentDone,
	direction,
}: SvgProps) => {

	if (direction === Direction[Direction.DELIVERY]) {
		return (
			<SvgDelivery
				className="transport-list-card-icon-direction"
				done={isAssignmentDone}
				alt={isAssignmentDone ? 'Levering utført' : 'Til levering'} />
		);
	}
	else {
		return (
			<SvgPickup
				className="transport-list-card-icon-direction"
				done={isAssignmentDone}
				alt={isAssignmentDone ? 'Henting utført' : 'For henting'} />
		);
	}
}

interface TripCardsStatsProps {
	data: Assignment,
}

const TripCardsStats = ({
	data,
}: TripCardsStatsProps) => {
	const deviations = useLiveQuery(() =>
		database.deviations.where('transportId').equals(data.id).toArray());
	const [expanded, setExpanded] = useState(false);
	const headerHeight = 50;
	const isAssignmentDone = isDone(data);
	const isPickup = data?.direction === AssignmentFilterType[AssignmentFilterType.PICKUP];
	const location = isPickup ? 'source' : 'destination';
	const priority = data?.goods?.priority === 'A';

	const renderDangerousGoodsIcon = () => {
		const goods: DangerousGoodsModel | undefined = data.goods?.dangerousGoods;
		if (goods && goods.unno) {
			return (
				<div className="transport-list-card-header-icon">
					<DangerousGoodsIcon
						className="transport-list-card-header-icon-info"
						dangerousGoods={goods}
						length={1}
						done={isAssignmentDone}
					/>
				</div>
			);
		}
		return null;
	};

	return (
		<div className="transport-list-card-header-wrapper"
				 role={!expanded ? 'button' : undefined}
				 onClick={() => {
					 if (!expanded) {
						 setExpanded(!expanded);
					 }
				 }}
				 tabIndex={!expanded ? 1 : undefined}
		>
			{ isAssignmentDone ?
				<div className="completedImage"
					style={{
						top: expanded ? '20%' : '',
					}}
				>
					<img src={TransportCompleted} alt="Transporten er bekreftet"/>
				</div> : null
			}
			<div className="transport-list-card-header"
					 onClick={() => {
						 if (expanded) {
							 setExpanded(!expanded);
						 }
					 }}
					 role={expanded ? 'button' : undefined}
					 tabIndex={expanded ? 1 : undefined}
			>
				<div className="transport-list-card-header-title">
					<TripDirectionSvg isAssignmentDone={isAssignmentDone} direction={data.direction} />
					{getAliasForGLN(data?.route?.[location].gln) || data?.route?.[location].name}
				</div>

				<div className="transport-list-card-header-icon">
					{deviations && deviations.length > 0 && (
						<SvgDeviation className="transport-list-card-header-icon-info" done={isAssignmentDone} alt="Transporten har avvik" />
					)}
				</div>

				{renderDangerousGoodsIcon()}

				<div className="transport-list-card-header-icon">
					{data?.goods?.temperatureControlled && (
						<SvgElectrical className="transport-list-card-header-icon-info" done={isAssignmentDone} alt="Tralle trenger strøm"/>
					)}
				</div>

				<div className="transport-list-card-header-icon">
					{priority && isPickup && (
						<SvgHighPriority
							className="transport-list-card-header-icon-info"
							done={isAssignmentDone} alt="Transporten har høy prioritet og hentes på båten"
						/>
					)}
				</div>
			</div>

			<Accordion
			  maxHeight={headerHeight}
				expanded={expanded}
				setExpanded={setExpanded}
				className="transport-list-card-expandable"
			>
				<TransportListCardDetails data={data} expanded={expanded} />
			</Accordion>
		</div>
	);
}

export default TripCardsStats;